import { render, staticRenderFns } from "./AssignBdoCardToOrder.vue?vue&type=template&id=3a19f319&scoped=true&"
import script from "./AssignBdoCardToOrder.vue?vue&type=script&lang=js&"
export * from "./AssignBdoCardToOrder.vue?vue&type=script&lang=js&"
import style0 from "./AssignBdoCardToOrder.vue?vue&type=style&index=0&id=3a19f319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19f319",
  null
  
)

export default component.exports